import { useDropzone } from "react-dropzone";
import { useEffect } from "react";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { useTranslation } from "react-i18next";
import { useTheme } from "@mui/material/styles";
import { useMediaQuery } from "@mui/material";

function DropzoneUploader({ onFileChange, minHeight = "200px" }) {
  const { t } = useTranslation();
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.between("mobile", "ipad"));
  const tablet = useMediaQuery(theme.breakpoints.between("ipad", "laptop"));

  const { getRootProps, getInputProps, acceptedFiles } = useDropzone({
    multiple: true,
    accept: {
      "application/pdf": [".pdf"],
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
        [".docx"],
    },
  });

  useEffect(() => {
    if (onFileChange) {
      onFileChange(acceptedFiles);
    }
  }, [acceptedFiles]);

  return (
    <div
      {...getRootProps()}
      style={{
        border: "2px dashed #DCEDFA",
        borderRadius: "8px",
        padding: "48px 24px",
        minHeight: minHeight,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        cursor: "pointer",
        backgroundColor: "#f7f9fa",
      }}
    >
      <input {...getInputProps()} />
      <CloudUploadIcon sx={{ fontSize: 64, color: "#439BD9", mb: 2 }} />
      <p
        style={{
          margin: "0",
          fontSize: "14px",
          fontWeight: 600,
          color: "#439BD9",
        }}
      >
        {(mobile || tablet) ? t("tapToUploadText") : t("dragAndDropText")}
      </p>
    </div>
  );
}

export default DropzoneUploader;
